import Vue from 'vue'

interface IParametersGetFreeRequest {
    fullUrl: string
}

interface IParametersPostFreeRequest {
    fullUrl: string
    dispatchParams: object
}

interface IParameters {
    baseProperty?: string
    fullUrl?: string
    dispatchParams?: object
    // isApiAdminRequest?: boolean
    isFreeRequest?: boolean
}

function getFullUrl({ baseProperty, fullUrl, isFreeRequest }: IParameters) {
    const url = fullUrl ? fullUrl : baseProperty
    if (isFreeRequest) return url
    return process.env.VUE_APP_DASHBOARD ? `/api_admin/${url}` : `/api/${url}`
}

const getSingularOfBaseProperty = (baseProperty: string) => baseProperty.slice(0, -1)

/**
 * generic method to fetch api data
 */

async function get({ baseProperty, fullUrl, isFreeRequest = false }: IParameters): Promise<any[]> {
    try {
        const { data } = await Vue.$axios.get(getFullUrl({ baseProperty, fullUrl, isFreeRequest }))
        // if it's an API request, return the correct data response
        if (!isFreeRequest) return data[baseProperty]
        else return data
    } catch (err) {
        console.error(err)
        throw err
    }
}

async function getFreeRequest({ fullUrl }: IParametersGetFreeRequest): Promise<any> {
    return get({ fullUrl, isFreeRequest: true })
}

async function post({ baseProperty, fullUrl, dispatchParams, isFreeRequest = false }: IParameters): Promise<any> {
    try {
        const { data } = await Vue.$axios.post(getFullUrl({ baseProperty, fullUrl, isFreeRequest }), dispatchParams)
        // if it's an API request, return the correct data response
        if (!isFreeRequest) return data[getSingularOfBaseProperty(baseProperty)]
        else return data
    } catch (err) {
        console.error(err)
        throw err
    }
}

async function postFreeRequest({ fullUrl, dispatchParams }: IParametersPostFreeRequest): Promise<any> {
    return post({ fullUrl, dispatchParams, isFreeRequest: true })
}

async function update({ baseProperty, fullUrl, dispatchParams, isFreeRequest = false }: IParameters): Promise<any[]> {
    try {
        const { data } = await Vue.$axios.patch(getFullUrl({ baseProperty, fullUrl, isFreeRequest }), dispatchParams)
        // they are all api requests
        return data[getSingularOfBaseProperty(baseProperty)]
    } catch (err) {
        console.error(err)
        throw err
    }
}

async function remove({ baseProperty, fullUrl, isFreeRequest = false }: IParameters): Promise<any[]> {
    try {
        const { data } = await Vue.$axios.delete(getFullUrl({ baseProperty, fullUrl, isFreeRequest }))
        // they are all api requests
        return data[getSingularOfBaseProperty(baseProperty)]
    } catch (err) {
        console.error(err)
        throw err
    }
}

export { get, getFreeRequest, post, postFreeRequest, update, remove }
